import {QueryBuilderReducerActionTypeEnum, QueryBuilderReducerDispatch, QueryBuilderStateQueryRule} from "../../../../index";
import React, {FunctionComponent, useCallback, useEffect, useState} from "react";
import {TextField, TextFieldProps} from "@mui/material";

export interface QueryBuilderValueInputNumberProps {
    rule: QueryBuilderStateQueryRule;
    allowDecimal: boolean;
    ruleIndex: number;
    conditionIndex: number;
    disabled: boolean;
    dispatch: QueryBuilderReducerDispatch;
}

const QueryBuilderValueInputNumber: FunctionComponent<QueryBuilderValueInputNumberProps> = ({
                                                                                                allowDecimal,
                                                                                                dispatch,
                                                                                                disabled,
                                                                                                rule,
                                                                                                ruleIndex,
                                                                                                conditionIndex,
                                                                                            }) => {
    const [value, setValue] = useState<string>((rule.value as number)?.toString() ?? "");

    /**
     * With each change in the [rule.value] prop:
     * - updates the local state.
     */
    useEffect(() => {
        setValue((rule.value as number)?.toString() ?? "")
    }, [rule.value]);

    /**
     * Changes the rule's value in the reducer for string types.
     */
    const changeNumberValue = useCallback<Required<TextFieldProps>['onChange']>((e) => {
        setValue(e.target.value)
    }, []);

    /**
     * Commits the rule's value in the reducer for string types.
     */
    const commitNumberValue = useCallback<Required<TextFieldProps>['onBlur']>((e) => {
        let parsed: number;
        if (allowDecimal) {
            parsed = parseFloat(e.target.value);
        } else {
            parsed = parseInt(e.target.value);
        }
        setValue(parsed.toString())
        dispatch({
            type: QueryBuilderReducerActionTypeEnum.ChangeValue,
            payload: {
                conditionIndex: conditionIndex,
                ruleIndex: ruleIndex,
                value: parsed,
            },
        })
    }, [dispatch, conditionIndex, ruleIndex, allowDecimal]);

    return (
        <>
            <TextField
                fullWidth
                label={`${allowDecimal ? "Decimal" : "Number"} Value`}
                variant={'outlined'}
                size={'small'}
                disabled={rule.displayEmptyValuesOnly || disabled}
                value={value ?? ""}
                onChange={changeNumberValue}
                onBlur={commitNumberValue}
                type={'number'}
                inputMode={'numeric'}
            />
        </>
    );
};
export default QueryBuilderValueInputNumber;
